import { useEffect, useState } from "react";
import "./smartDashboard.css";
import HeaderComponent from "../header/header";
import ProfileFormComponent from "../profile/profile.membership.component";
import SubscriptionFormComponent from "../subscription/subscription.membership.component";
import MembershipFormComponent from "../membership/membership.form.component";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";
import { getActiveUserSubscriptionDetails } from "../../services/subscription.service";
import RegistrationDetailsComponent from "../admin/registrartionDetails.component";
import MembershipFeeComponent from "../admin/membershipFee.master.component";
import EventNoticeComponent from "../admin/eventNotice.component";
import { getUserInfo } from "../../services/profile.service";
import CertificateComponent from "../certificate/certificate.component";
import GalleryList from "../gallery/galleryList.component";
import PaymentDetails from "../payment/paymentDetails.component";

const SmartDashboardComponent = () => {
  const [activeTab, setActiveTab] = useState("v-pills-profile");
  const [userInfo, setUserInfo] = useState("");
  const [Role, setRole] = useState('');
  const [userSubscribed, setUserSubcribed] = useState('false');
  const [isLoading, setIsLoading] = useState(false);
  const [userSubscriptionDetails, setUserSubscriptionDetails] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const userInfoDetails = await getUserInfo();
      if (userInfoDetails && userInfoDetails.length > 0) {
        const userInfo = userInfoDetails[0];
        setUserInfo(userInfo);
        setRole(userInfo.role);
        const userSubscriptionDetails = await getActiveUserSubscriptionDetails();
        setUserSubscriptionDetails(userSubscriptionDetails);
        if (userSubscriptionDetails) {
          setUserSubcribed('true');
        }
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Initial load and when location state changes
  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
      navigate(location.pathname, { replace: true });
    }
    fetchData();
  }, [location, navigate]);



  return (
    <div className="smart-wrapper">
      <Helmet>
        <title>DASHBOARD SMARTFORUM - Society for Microwaves, Antennas and Radar Technologies</title>
        <meta name="description" content="Join SMART, a technology-driven community shaping the future of innovation, research, and collaboration." />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <HeaderComponent />
      <section id="fixed-sub-nav" className="fade-in main-wrapper">

        <div className="container-fluid pt-4 fade-in main-wrapper">
          <div className="row">
            <div className="col-md-2 dashboard-smart-side-tab">
              <div
                className="nav flex-column nav-pills nav-pills-custom"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                <a className={`nav-link mb-3 px-2 py-2 shadow ${activeTab === "v-pills-profile" ? "active" : ""
                  }`}
                  id="v-pills-profile-tab"
                  role="tab"
                  onClick={() => setActiveTab("v-pills-profile")}
                >
                  <span className="font-weight-bold small text-uppercase">
                    Profile
                  </span>
                </a>

                <a
                  className={`nav-link mb-3 px-2 py-2  shadow ${activeTab === "v-pills-subscription" ? "active" : ""
                    }`}
                  id="v-pills-subscription-tab"
                  role="tab"
                  onClick={() => setActiveTab("v-pills-subscription")}
                >
                  <span className="font-weight-bold small text-uppercase">
                    Subscription
                  </span>
                </a>


                {userSubscribed === 'true' && (
                  <>
                    <a
                      className={`nav-link mb-3 px-2 py-2  shadow ${activeTab === "v-pills-membership" ? "active" : ""
                        }`}
                      id="v-pills-membership-tab"
                      role="tab"
                      onClick={() => setActiveTab("v-pills-membership")}
                    >
                      <span className="font-weight-bold small text-uppercase">
                        Membership
                      </span>
                    </a>
                    <a
                      className={`nav-link mb-3 px-2 py-2  shadow ${activeTab === "v-pills-certificate" ? "active" : ""
                        }`}
                      id="v-pills-certificate-tab"
                      role="tab"
                      onClick={() => setActiveTab("v-pills-certificate")}
                    >
                      <span className="font-weight-bold small text-uppercase">
                        Certificate
                      </span>
                    </a>
                  </>
                )}

                {Role !== null && Role === 'ROLE_ADMIN' && (
                  <>
                    <a
                      className={`nav-link mb-3 px-2 py-2  shadow ${activeTab === "v-pills-membership-fee" ? "active" : ""
                        }`}
                      id="v-pills-membership-fee-tab"
                      role="tab"
                      onClick={() => setActiveTab("v-pills-membership-fee")}
                    >
                      <span className="font-weight-bold small text-uppercase">
                        Membership Fee
                      </span>
                    </a>
                    <a
                      className={`nav-link mb-3 px-2 py-2  shadow ${activeTab === "v-pills-registration-details" ? "active" : ""
                        }`}
                      id="v-pills-registration-details-tab"
                      role="tab"
                      onClick={() => setActiveTab("v-pills-registration-details")}
                    >
                      <span className="font-weight-bold small text-uppercase">
                        Registration Details
                      </span>
                    </a>
                    <a
                      className={`nav-link mb-3 px-2 py-2  shadow ${activeTab === "v-pills-payment-details" ? "active" : ""
                        }`}
                      id="v-pills-payment-details-tab"
                      role="tab"
                      onClick={() => setActiveTab("v-pills-payment-details")}
                    >
                      <span className="font-weight-bold small text-uppercase">
                        Payment Details
                      </span>
                    </a>
                    <a
                      className={`nav-link mb-3 px-2 py-2  shadow ${activeTab === "v-pills-event-notice" ? "active" : ""
                        }`}
                      id="v-pills-event-notice-tab"
                      role="tab"
                      onClick={() => setActiveTab("v-pills-event-notice")}
                    >
                      <span className="font-weight-bold small text-uppercase">
                        Event Notice
                      </span>
                    </a>
                    <a
                      className={`nav-link mb-3 px-2 py-2  shadow ${activeTab === "v-pills-gallery" ? "active" : ""
                        }`}
                      id="v-pills-gallery-tab"
                      role="tab"
                      onClick={() => setActiveTab("v-pills-gallery")}
                    >
                      <span className="font-weight-bold small text-uppercase">
                        Gallery
                      </span>
                    </a>
                  </>
                )}

              </div>
            </div>

            <div className="col-md-10 dashboard-smart-tab-content">
              <div className="tab-content " id="v-pills-tabContent">

                {/* PROFILE TAB START */}
                <div
                  className={`tab-pane fade shadow rounded  dashboard-tab ${activeTab === "v-pills-profile" ? "show active" : ""
                    }`}
                  id="v-pills-profile"
                  role="tabpanel"
                  style={{ paddingTop: '0px!important' }}
                >

                  <ProfileFormComponent key={activeTab} />
                </div>
                {/* PROFILE TAB END */}


                {/* SUBSCRIPTION TAB START */}
                <div
                  className={`tab-pane fade shadow rounded dashboard-tab ${activeTab === "v-pills-subscription" ? "show active" : ""
                    }`}
                  id="v-pills-subscription"
                  role="tabpanel"
                >
                  <SubscriptionFormComponent key={activeTab} />
                </div>
                {/* SUBSCRIPTION TAB END */}


                {/* MEMBERSHIP TAB START */}
                {userSubscribed === 'true' && (
                  <>
                    <div
                      className={`tab-pane fade shadow rounded   dashboard-tab ${activeTab === "v-pills-membership" ? "show active" : ""
                        }`}
                      id="v-pills-membership"
                      role="tabpanel"
                    >
                      <MembershipFormComponent key={activeTab} />
                    </div>
                    <div
                      className={`tab-pane fade shadow rounded   dashboard-tab ${activeTab === "v-pills-certificate" ? "show active" : ""
                        }`}
                      id="v-pills-certificate"
                      role="tabpanel"
                    >
                      <CertificateComponent userData={userSubscriptionDetails} key={activeTab} />
                    </div>
                  </>
                )}
                {/* MEMBERSHIP TAB END */}


                {Role !== null && Role === 'ROLE_ADMIN' && (
                  <>
                   {/* MEMBERSHIP FEE TAB */}
                  <div
                    className={`tab-pane fade shadow rounded   dashboard-tab ${activeTab === "v-pills-membership-fee" ? "show active" : ""
                      }`}
                    id="v-pills-membership-fee"
                    role="tabpanel"
                  >
                    <MembershipFeeComponent key={activeTab} />
                  </div>
                   {/*REGISTRATION DETAILS TAB */}
                  <div
                    className={`tab-pane fade shadow rounded   dashboard-tab ${activeTab === "v-pills-registration-details" ? "show active" : ""
                      }`}
                    id="v-pills-registration-details"
                    role="tabpanel"
                  >
                    <RegistrationDetailsComponent key={activeTab} />
                  </div>
                   {/*PAYMENT DETAILS TAB */}
                  <div
                    className={`tab-pane fade shadow rounded   dashboard-tab ${activeTab === "v-pills-payment-details" ? "show active" : ""
                      }`}
                    id="v-pills-payment-details"
                    role="tabpanel"
                  >
                    <PaymentDetails key={activeTab} />
                  </div>
                   {/*EVENTNOTICE DETAILS TAB */}
                  <div
                      className={`tab-pane fade shadow rounded   dashboard-tab ${activeTab === "v-pills-event-notice" ? "show active" : ""
                        }`}
                      id="v-pills-event-notice"
                      role="tabpanel"
                    >
                      <EventNoticeComponent key={activeTab} />
                    </div>
                   {/*GALLERY DETAILS TAB */}
                    <div
                      className={`tab-pane fade shadow rounded   dashboard-tab ${activeTab === "v-pills-gallery" ? "show active" : ""
                        }`}
                      id="v-pills-gallery-tab"
                      role="tabpanel"
                    >
                      <GalleryList key={activeTab} />
                    </div>
                  </>
                )}


                {/*EVENT NOTICE TAB START */}
                {Role !== null && Role === 'ROLE_ADMIN' && (
                  <>
      
                  </>
                )}
                {/*EVENT NOTICE TAB END */}


              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default SmartDashboardComponent;
